import type { SimilarItemAlertsSort } from '@/redux/modules/similarItemAlerts/similarItemAlerts.types';

/**
 * The sorts the For You "My Similar Item Alerts" tab offers.
 *
 * These are savedsearch-api's own `GET /saved-items?sort=` values, used verbatim as the URL's `sort`
 * so nothing has to translate between the two — the backend falls through to `savedNewest`
 * *silently* on a value it doesn't know, so a mapping layer here would sort wrongly with no error.
 * Keyed by value because `validateQueryParams` looks the URL's sort up as a key of this map.
 * (`titleZA` exists on the backend too; the design doesn't offer it.)
 */
export const similarItemAlertsSortOrders = {
    savedNewest: 'savedNewest',
    savedOldest: 'savedOldest',
    titleAZ: 'titleAZ',
} as const satisfies Record<string, SimilarItemAlertsSort>;

export const DEFAULT_SIMILAR_ITEM_ALERTS_SORT = similarItemAlertsSortOrders.savedNewest;
